import { CheckoutSessionOwnershipProvider } from "@circle-react/components/Paywalls/Checkout/contexts/CheckoutSessionOwnershipContext";
import { RouterProvider } from "@tanstack/react-router";
import { useState } from "react";

import { createTanstackRouter } from "@/react/utils/router/createTanstackRouter";

import { paywallCheckoutRouteTree } from "./routeTree";

interface PaywallCheckoutAppRouterProps {
  paywallId: number;
}

const createPaywallCheckoutRouter = (paywallId: number) =>
  createTanstackRouter({
    routeTree: paywallCheckoutRouteTree,
    context: { paywallId },
  });

export type PaywallCheckoutRouter = ReturnType<
  typeof createPaywallCheckoutRouter
>;

export const PaywallCheckoutAppRouter = ({
  paywallId,
}: PaywallCheckoutAppRouterProps) => {
  const [router] = useState(() => createPaywallCheckoutRouter(paywallId));

  return (
    <CheckoutSessionOwnershipProvider>
      <RouterProvider router={router} />
    </CheckoutSessionOwnershipProvider>
  );
};
